var _g, _line, _line2, _line3, _defs, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonDetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 44,
    viewBox: "0 0 47 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_414_1436)"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1.1,0,0,1.1,-1.2,-1.4)",
    y: 2.1,
    x: 2,
    width: 43,
    height: 40,
    rx: 6,
    fill: "white"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 10.3021,
    x2: 36.4184,
    y2: 10.3021,
    stroke: "url(#paint0_linear_414_1436)",
    strokeWidth: 3.39576
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 19.7137,
    x2: 36.4184,
    y2: 19.7137,
    stroke: "url(#paint1_linear_414_1436)",
    strokeWidth: 3.39576
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 29.1256,
    x2: 36.4184,
    y2: 29.1256,
    stroke: "url(#paint2_linear_414_1436)",
    strokeWidth: 3.39576
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_414_1436",
    x: 0,
    y: 0,
    width: 47,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_414_1436"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_414_1436",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_414_1436",
    x1: 12,
    y1: 12.5,
    x2: 36.4184,
    y2: 12.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3290ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#246cb3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_414_1436",
    x1: 12,
    y1: 21.9116,
    x2: 36.4184,
    y2: 21.9116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3290ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#246cb3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_414_1436",
    x1: 12,
    y1: 31.3235,
    x2: 36.4184,
    y2: 31.3235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3290ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#246cb3"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25.5,
    y: 19.6,
    width: 0,
    height: 0,
    fill: "rgb(255, 255, 255)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonDetail);
export default __webpack_public_path__ + "static/media/button-detail.d4181a1cafad794099191082184c5daf.svg";
export { ForwardRef as ReactComponent };